import React from 'react';
import PropTypes from 'prop-types';
import { OrderView } from '../../../orders/order';
import { Button } from '@ami/react/core';
import { ordersService } from '../../../orders/ordersService';
import { downloadWithFallback } from '@ami/react/core';
import { appConfig } from '@ami/react/core';
import { withRouter } from 'react-router-dom';
import { orderStatus } from '../../../orders/order';
import { orderNumberPipe } from "../../../orderNumberPipe";
import {
  Collapse,
  Nav,
  Navbar,
  NavbarBrand,
  NavItem,
  NavbarToggler,
} from 'reactstrap';
import {
  isAmiUserAuthorizedToViewOrders,
  isAmiUserAuthorizedToManageOrders,
  isAmiUserAuthorizedToManageOrderShipping,
} from '../../../authorization/amiPermissions';

import { Link } from 'react-router-dom';

class OrderHeaderComponent extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false,
      downloadingPdf: false,
    };
  }

  static propTypes = {
    order: PropTypes.instanceOf(OrderView).isRequired,
    onCancel: PropTypes.func.isRequired,
    onAddCustomActivity: PropTypes.func.isRequired,
    onManageShipments: PropTypes.func.isRequired,
    onRequestShipDateTime: PropTypes.func.isRequired,
  };

  downloadAsPdf = async (order) => {
    this.setState({ downloadingPdf: true });
    ordersService.downloadPdf(order.id).then((blob) => {
      downloadWithFallback(blob, `Order-${order.workOrderNumber}.pdf`);
      this.setState({ downloadingPdf: false });
    });
  };

  edit = () => {
    this.props.history.push(`/orders/edit/${this.props.order.id}`);
  };

  toggle = () => {
    this.setState({ isOpen: !this.state.isOpen });
  };

  render() {
    const { order } = this.props;
    const { downloadingPdf } = this.state;

    return (
      <Navbar color="dark" dark expand="md" className="order-header">
        <div className="row">
          <div className="col-lg-6">
            <NavbarBrand>
              <h2 className="page-title">
                <div title={order.name}>{order.name}</div>
                <div className="subtitle pull-left mt-1 me-2">
                  Order {orderNumberPipe(order.id)}, PO {order.poNumber}
                </div>
                <div className="order-status">
                  {order.status === orderStatus.cancelled.id && (
                    <span className="badge text-bg-danger">
                      {orderStatus.cancelled.label}
                    </span>
                  )}
                  {order.status === orderStatus.shippingCompleted.id && (
                    <span className="badge text-bg-success">
                      {orderStatus.shippingCompleted.label}
                    </span>
                  )}
                </div>
              </h2>
            </NavbarBrand>
          </div>
          <div className="col-lg-6">
            <NavbarToggler onClick={this.toggle} className="" />
            <Collapse isOpen={this.state.isOpen} navbar>
              <Nav className="order-nav" navbar>
                <div className="row buttons-wrapper justify-content-end">
                  <NavItem>
                    <Button
                      label="PDF"
                      onClick={() => this.downloadAsPdf(order)}
                      className="btn-primary w-100"
                      iconName="download"
                      showSpinner={downloadingPdf}
                      disabled={downloadingPdf}
                    />
                  </NavItem>
                  {appConfig.isManagementApp &&
                    order.canBeEdited &&
                    isAmiUserAuthorizedToManageOrders() && (
                      <NavItem>
                        <Button
                          label="Edit"
                          onClick={this.edit}
                          className="btn-primary w-100"
                        />
                      </NavItem>
                    )}
                  {appConfig.isManagementApp &&
                    isAmiUserAuthorizedToManageOrders() && (
                      <NavItem>
                        <Button
                          label="Add Activity"
                          onClick={this.props.onAddCustomActivity}
                          className="btn btn-primary w-100"
                        />
                      </NavItem>
                    )}
                  {appConfig.isManagementApp &&
                    order.canBeEdited &&
                    isAmiUserAuthorizedToManageOrderShipping() && (
                      <NavItem>
                         <Link to={`/orders/shipments/${order.id}`}>
                        <Button
                          label="Manage Shipments"
                          className="btn btn-primary w-100"
                        />
                        </Link>
                      </NavItem>
                    )}
                  {appConfig.isManagementApp &&
                    order.canBeEdited &&
                    isAmiUserAuthorizedToViewOrders() && (
                      <NavItem>
                        <Button
                          label="Ship Date Request"
                          onClick={this.props.onRequestShipDateTime}
                          className="btn btn-primary w-100"
                        />
                      </NavItem>
                    )}
                  {appConfig.isManagementApp &&
                    order.canBeCanceled &&
                    isAmiUserAuthorizedToManageOrders() && (
                      <NavItem>
                        <Button
                          label="Cancel"
                          onClick={this.props.onCancel}
                          className="btn btn-danger w-100"
                        />
                      </NavItem>
                    )}
                </div>
              </Nav>
            </Collapse>
          </div>
        </div>
      </Navbar>
    );
  }
}

export default withRouter(OrderHeaderComponent);
